import { useLocale } from '@atlassian/jira-tenant-context-controller/src/components/locale/index.tsx';
import { useUserSubscriber } from '@atlassian/jira-user-services/src/main.tsx';

export function useLocaleTimeZone() {
	const locale = useLocale();
	const [{ data }] = useUserSubscriber();

	return { locale, timeZone: data?.timeZone };
}
